import { DualSelect } from './DualSelect';

export default DualSelect;
